import ThemeWrapper from "../dist/ThemeWrapper";

export default function Win98theme() {
  return (
    <ThemeWrapper 
      title="Win 98 Theme" 
      cssUrl="https://unpkg.com/98.css" 
      isDarkMode={false} 
    />
  );
}